import { useToasteo } from '@deegital/vue-trustup-io-toasteo';

export default function useToasteoInfo(translationKeyOrText: string = 'toasts.error', raw: boolean = false) {
    const { t } = useTranslation();
    const toasteo = useToasteo();

    return toasteo.info({
        text: raw ? translationKeyOrText : t(translationKeyOrText),
    });
}
